import styled from 'styled-components';
import Input from 'components/ui/Input';
import Select from 'components/ui/Select';
import Label from 'components/ui/Label';

import { colours } from 'themes/default';

export const StyledForm = styled.form`
  display: flex;
  flex-flow: column;
  background-color: ${colours.Shades.TintBlue10};
  padding: 10px;
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 16px;
`;

export const StyledInput = styled(Input)`
  line-height: 1;
  box-sizing: border-box;
`;

export const StyledSelect = styled(Select)`
  width: 100%;
`;

export const StyledSubmitField = styled.div`
  text-align: right;
`;

export const MandatoryFieldLabel = styled(Label)`
  &::after {
    content: ' *';
    color: red;
  }
`;

export const Field = styled.div`
  margin: 0.4em 0;
  display: inline-block;
  width: 100%;
`;

export const ErrorField = styled.div`
  color: red;
`;

export const StyledOfficeLocation = styled.div`
  margin: 15px 0;
`;
